import React, { useContext, useState } from 'react';
import { ExhibitLightboxContext } from './ExhibitLightboxContext';

/** A picture carried in the image_url field rather than written into the HTML.
 *
 * Papers hold artwork two ways: an <img> inside the question or passage HTML,
 * and a bare URL in image_url. Only the first was ever rendered, so 2,028
 * questions showed no stem image and 224 showed their options as bare letters.
 * ESAT Mock 1 Section B question 1 asks which velocity-time graph is correct
 * and drew none of the seven pictures it needs. */
const PaperImage = ({ url, alt, maxHeight = '480px' }) => {
  const { openLightbox } = useContext(ExhibitLightboxContext) || {};
  // Some options carry a broken/blank/legacy image_url alongside their real
  // diagram embedded in the option's own HTML text — rendering a trigger
  // button+badge for a picture that never loads leaves a floating, useless
  // expand icon with nothing visible attached to it, so hide entirely on error.
  const [failed, setFailed] = useState(false);
  if (!url || typeof url !== 'string' || !url.trim() || failed) return null;
  const trimmedUrl = url.trim();
  return (
    <button
      type="button"
      className="exhibit-image-trigger"
      onClick={(e) => {
        // This button can sit inside a <label> wrapping an option's radio
        // input (see the option-row PaperImage usage) - a native click
        // anywhere inside activates the input regardless of stopPropagation,
        // preventDefault is what actually blocks that.
        e.preventDefault();
        e.stopPropagation();
        openLightbox && openLightbox({ url: trimmedUrl, alt });
      }}
      aria-label="Expand image"
    >
      <img
        className="tmua-pearson-figure"
        src={trimmedUrl}
        alt={alt || ''}
        loading="lazy"
        onError={() => setFailed(true)}
        style={{
          display: 'block',
          maxWidth: '100%',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
          maxHeight,
          margin: '12px 0',
        }}
      />
      <span className="exhibit-image-trigger-badge" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </button>
  );
};

export default PaperImage;
